import styled from 'styled-components';

export const ForgotPasswordContainer = styled.div`
  margin-top: 74px;
`;
